import React from "react";
import { useEffect, useState } from "react";
import NetworkError from "./components/NetworkError";
import { helpers, storage } from "./services";
import i18next from "i18next";
import Actions from "./store/actions";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { Modal } from "./components";
import ModulesActions from "modules/entity/actions";
import "./assets/styles/output.css";
import "./assets/styles/antd.css";
import { Inspector } from "react-inspect-overlay";

const App = ({ children }) => {
	const auth = useSelector(state => state.auth);
	const currentLangCode = useSelector(state => state.system.currentLangCode);
	const showChangeOrganizationModal = useSelector(
		state => state.system.showChangeOrganizationModal
	);
	const storageToken = storage.get("token");
	const dispatch = useDispatch();
	const [selectOrganizationModal, showSelectOrganizationModal] = useState(
		false
	);
	const [selectedOrgId, setSelectedOrgId] = useState(null);
	const [isSubmitting, setSubmitting] = useState(false);
	const profile = useSelector(state => get(state.auth, "user"));

	const setLanguage = () => {
		if (helpers.isEnableLang(storage.get("language"))) {
			dispatch(Actions.system.ChangeLanguage(storage.get("language")));
			i18next.changeLanguage(storage.get("language"));
		} else {
			dispatch(Actions.system.ChangeLanguage(currentLangCode));
			i18next.changeLanguage(currentLangCode);
		}
	};

	useEffect(() => {
		if (storageToken) {
			dispatch(Actions.auth.GetMe());
		}
		setLanguage();
	}, []);

	useEffect(() => {
		if (get(auth, "isAuthenticated")) {
			const role = get(profile, "role.role");
			if (role === "owner") {
				dispatch(Actions.system.GetCurrencyRates());
				dispatch(Actions.system.GetUnits());
				dispatch(Actions.system.GetStorages());
				dispatch(Actions.system.GetPaymentTypes());
			} else {
				dispatch(Actions.system.GetCurrencyRates());
				dispatch(Actions.system.GetUnits());
				dispatch(Actions.system.GetStorages());
				dispatch(Actions.system.GetPaymentTypes());

				if (!get(profile, "organization_id")) {
					setTimeout(() => {
						showSelectOrganizationModal(true);
						if (document.querySelector(".devent-content")) {
							document.querySelector(".devent-content").style.filter =
								"blur(60px)";
						}
					}, 500);
				}
			}
		}
	}, [get(auth, "isAuthenticated")]);

	useEffect(() => {
		if (showChangeOrganizationModal) {
			showSelectOrganizationModal(true);
			if (document.querySelector(".devent-content")) {
				document.querySelector(".devent-content").style.filter = "blur(60px)";
			}
		}
	}, [showChangeOrganizationModal]);

	const token = storageToken || get(auth, "token");
	const mockData = { isFetched: true, isAuthenticated: false, data: null };

	const handleSubmitSetOrganization = id => {
		setSubmitting(true);
		dispatch(
			ModulesActions.FormDefault.request({
				url: "/user/update-me",
				method: "put",
				values: {
					organization_id: selectedOrgId
				},
				cb: {
					success: () => { },
					error: () => { },
					finally: () => {
						window.location.reload();
					}
				}
			})
		);
	};

	return (
		<div className="h-full">
			<div
				className={`blur-backdrop ${selectOrganizationModal ? "--active" : ""}`}
			></div>

			<Modal
				size={500}
				isOpen={selectOrganizationModal}
				backdrop={false}
				closeIcon={!!get(profile, "organization_id")}
				toggle={() => {
					showSelectOrganizationModal(false);
					if (document.querySelector(".devent-content")) {
						document.querySelector(".devent-content").style.filter = "none";
					}
					dispatch(Actions.system.ToggleOrganizationModal(false));
				}}
			>
				<div className="modal-body">
					<h3 className="mt-0">Выберите точку</h3>
					<div className="row mb-24">
						{get(profile, "organizations", []).map(org => {
							return (
								<div className="col-12 mb-10" key={org.id}>
									<div
										className={`radio-item ${selectedOrgId === org.id ? "--checked" : ""
											}`}
										onClick={() => setSelectedOrgId(org.id)}
									>
										<span className="radio-item-check"></span>
										<span>{org.name}</span>
									</div>
								</div>
							);
						})}
					</div>
					<button
						onClick={handleSubmitSetOrganization}
						type="button"
						className={`d-btn d-btn--full d-btn-primary ${isSubmitting ? "--loading" : ""
							}`}
						disabled={isSubmitting || !selectedOrgId}
					>
						Перейти
					</button>
				</div>
			</Modal>
			<NetworkError />
			<Inspector />
			<div id="custom-alert-zone" />
			{children(token ? auth : mockData)}
		</div>
	);
};

export default App;
